export interface ScoreGaugeProps {
  score: number; // 0..100
  label: string;
}

export function ScoreGauge({ score, label }: ScoreGaugeProps): JSX.Element {
  const clamped = Math.max(0, Math.min(100, score));
  const r = 74;
  const circ = 2 * Math.PI * r;
  const dash = (clamped / 100) * circ;
  return (
    <div className="gauge">
      <svg width="168" height="168" viewBox="0 0 168 168" aria-hidden="true">
        <circle cx="84" cy="84" r={r} fill="none" stroke="var(--bg-overlay)" strokeWidth="12" />
        <circle
          cx="84"
          cy="84"
          r={r}
          fill="none"
          stroke="var(--ml-yellow)"
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circ}`}
          style={{ filter: "drop-shadow(0 0 8px var(--ml-yellow-glow))", transition: "stroke-dasharray 700ms var(--ease)" }}
        />
      </svg>
      <div className="gauge__center">
        <div className="gauge__score tnum">{Math.round(clamped)}</div>
        <div className="gauge__label">{label}</div>
      </div>
    </div>
  );
}
